import React from "react";
import styles from './styles';
import URLS from '../../../config/navigation';
import profileIcon from '../../../assets/img/profileIcon.svg';
import profileIconActive from '../../../assets/img/profileIconActive.svg';
import paymentsIcon from '../../../assets/img/money-bag-dollar.svg';
import paymentsIconActive from '../../../assets/img/money-bag-dollar-active.svg';
import settingsIcon from '../../../assets/img/settingsIcon.svg';
import settingsIconActive from '../../../assets/img/settingsIconActive.svg';
import { useHistory, useLocation } from 'react-router-dom';

const links = [
  {
    name: 'Profile',
    img: profileIcon,
    activeImg: profileIconActive,
    link: URLS.PROFILE.DATA
  },
  {
    name: 'Payments',
    img: paymentsIcon,
    activeImg: paymentsIconActive,
    link: URLS.PROFILE.PAYMENTS
  },
  {
    name: 'Settings',
    img: settingsIcon,
    activeImg: settingsIconActive,
    link: URLS.SETTINGS.SETTINGS_MOBILE
  },
]


const BottomMobileNavigation = () => {
  const classes = styles();
  const location = useLocation();
  const history = useHistory()

  const handleNavigate = (url) => {
    history.push(url);
  };

  return (
    <div className={classes.bottomNavigationContainer + " bottomNavigation"}>
      <div className={classes.bottomNavigationWrapper}>
        {
          links.map((item, index) =>
            (<div
              className={item.link === location.pathname ? `${classes.bottomLink} ${classes.active}` : classes.bottomLink}
              onClick={() => handleNavigate(item.link)}
              key={index}
            >
              <img className={classes.bottomLinkImg} src={item.link === location.pathname ? item.activeImg : item.img} alt={item.name}/>
              <span className={item.link === location.pathname ? `${classes.linkName} ${classes.active}` : classes.linkName}>
                {item.name}
              </span>
            </div>)
          )
        }
      </div>
    </div>
  );
}

export default BottomMobileNavigation;
